import properties from '../../helpers/config';

export const SITE_BASE_URL = `${process.env.REACT_APP_HOST_URL}`;
export const BASE_URL = `${properties.baseApiUrL}`;
export const API_BASE_URL = `${BASE_URL}/en/api`;
